import './Dashboard.css';
import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslate } from 'react-redux-multilingual';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LinkMui from '@mui/material/Link';
import DiamondIcon from '@mui/icons-material/Diamond';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import ProjectManagement from '../../../libraries/Images/projectManagementDashboard.png';
import Sales from  '../../../libraries/Images/salesDashboard.png';

import {
    GetPlanInfor,
    GetTodayTasks,
} from '../../../services/Dashboard.service';

function Dashboard(props) {
    const { translate, UserInfor } = props;
    const navigate = useNavigate();
    const [todayTasks, setTodayTasks] = React.useState([]);
    const [planInfor, setPlanInfor] = React.useState({});
    const [actualResults, setActualResults] = React.useState({});
    const [numberOfValidDays, setNumberOfValidDays] = React.useState(-1);

    useEffect(async () => {
        let event;
        window.scrollTo({ top: 0, behavior: "smooth" });
        props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
        event = GetPlanInfor();
        event?.then(res => {
            setPlanInfor(res.data.planInfor);
            setActualResults(res.data.actualResults);
            setNumberOfValidDays(parseInt((((new Date(res.data.actualResults?.period?.endDate) - new Date()) + (24 * 60 * 60 * 1000)) / (24 * 60 * 60 * 1000))));
            GetTodayTasks()
            .then(res => {
                setTodayTasks(res.data.datas);
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            })
            .catch (e => {
                navigate(`/signin`);
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            });
        })
        .catch (e => {
            navigate(`/signin`);
            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
        });
    }, [])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                {(numberOfValidDays >= 0 && numberOfValidDays <= 10) &&
                <Grid item xs={12}>
                    <Box className="dashboard-box alert-box">
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h6" component="div" className='title'>
                                    {translate('expirationnotice', { numberOfValidDays })}
                                </Typography>
                                <Typography variant="body1" component="div" className='sub-title'>
                                    {`${translate('expirationnotice_2')} ${translate('email')}`}&nbsp;<LinkMui underline="none" href={`mailto:${process.env.REACT_APP_INFOR_SALE_MAIL}`}>{process.env.REACT_APP_INFOR_SALE_MAIL}</LinkMui> &nbsp;{`${translate('orphone')}`}&nbsp;<LinkMui underline="none" href={`tel:${process.env.REACT_APP_INFOR_SALE_TEL}`}>{process.env.REACT_APP_INFOR_SALE_TEL}</LinkMui>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>}
                <Grid item xs={12}>
                    <Box className="dashboard-box">
                        <Grid container spacing={3}>
                            <Grid item xs={9}>
                                <Typography variant="h6" component="div" className='title'>
                                    {translate('dashboarddescription')}
                                </Typography>
                                <Typography variant="body1" component="div" className='sub-title'>
                                    {translate('dashboarddescription_2')}
                                </Typography>
                                <Box className='current-plan'>
                                    <Box sx={{ display: "flex", alignItems: "center", color: "#fff" }}>
                                        <CalendarMonthOutlinedIcon fontSize='large' />
                                        <Box>
                                            <Typography variant="body1" component="div" className='sub-title'>
                                                {translate('currentplan')}:&nbsp;<strong className='package'>{planInfor.name?.charAt(0).toUpperCase() + planInfor.name?.slice(1).toLowerCase()}</strong>
                                            </Typography>
                                            <Typography variant="body2" component="div" className='sub-title'>
                                                {translate('usageperiod')}:&nbsp;<strong className='date'>{actualResults?.period?.startDate}</strong>&nbsp;-&nbsp;<strong className='date'>{actualResults?.period?.endDate}</strong>
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Button variant="contained" color="success" startIcon={<DiamondIcon />} onClick={() => navigate(`/contact/upgrade`)}>
                                        {translate('upgrade')}
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={3} sx={{ textAlign: "center"}}>
                                <img width={200} src={Sales}/>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={3}>
                            <Box className="dashboard-box">
                                <Box px={4} sx={{ display: "flex", alignItems: "center" }}>
                                    <Box className='workspace-dashboard-box'>
                                        <PrecisionManufacturingOutlinedIcon />
                                    </Box>
                                    <Box>
                                        <span className='title-box'>{translate('workspace')}</span>
                                        <h3 className='number-box'>{actualResults.robot}&nbsp;/&nbsp;{planInfor.robot}&nbsp;<span className='unit-box'>{translate('robotunit')}</span></h3>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box className="dashboard-box">
                                <Box px={4} sx={{ display: "flex", alignItems: "center" }}>
                                    <Box className='connection-dashboard-box'>
                                        <LanOutlinedIcon />
                                    </Box>
                                    <Box>
                                        <span className='title-box'>{translate('connection')}</span>
                                        <h3 className='number-box'>{actualResults.connection}&nbsp;/&nbsp;{planInfor.connection}&nbsp;<span className='unit-box'>{translate('connectunit')}</span></h3>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box className="dashboard-box">
                                <Box px={4} sx={{ display: "flex", alignItems: "center" }}>
                                    <Box className='storage-dashboard-box'>
                                        <FolderOutlinedIcon />
                                    </Box>
                                    <Box>
                                        <span className='title-box'>{translate('storage')}</span>
                                        <h3 className='number-box'>{(actualResults.storage / Math.pow(1024, 3)).toFixed(1)}&nbsp;/&nbsp;{planInfor.storage}&nbsp;<span className='unit-box'>{translate('gbunit')}</span></h3>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box className="dashboard-box">
                                <Box px={4} sx={{ display: "flex", alignItems: "center" }}>
                                    <Box className='schedule-dashboard-box'>
                                        <ScheduleOutlinedIcon />
                                    </Box>
                                    <Box>
                                        <span className='title-box'>{translate('schedule')}</span>
                                        <h3 className='number-box'>{actualResults.schedule}&nbsp;/&nbsp;{planInfor.schedule}&nbsp;<span className='unit-box'>{translate('taskunit')}</span></h3>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box className="dashboard-box">
                        <Typography variant="h6" component="div" className='title'>
                            {translate('tasksdonetoday')}
                        </Typography>
                        <Box px={1} sx={{ maxHeight: 300, overflowY: "auto" }}>
                            <Table stickyHeader sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">#</TableCell>
                                        <TableCell align="center">{translate('status')}</TableCell>
                                        <TableCell sx={{ minWidth: 200 }}>{translate('robotname')}</TableCell>
                                        <TableCell align="left">{translate('description')}</TableCell>
                                        <TableCell align="left" sx={{ minWidth: 140 }}>{translate('startdatetime')}</TableCell>
                                        <TableCell align="left" sx={{ minWidth: 140 }}>{translate('enddatetime')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {todayTasks?.map((row, index) => (
                                    <TableRow
                                        key={row.historiesID}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell align="center">{(index + 1)}</TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{color: (row.statusCd === 0 ? 'rgb(208, 219, 10)' : row.statusCd === 1 ? 'info.main' : 'error.main')}} variant="subtitle2">
                                            {row.statusCd === 0 ? translate('running') : row.statusCd === 1 ? translate('success') : translate('error')}
                                            </Typography>
                                        </TableCell>
                                        <TableCell scope="row">
                                            {row.name}
                                        </TableCell>
                                        <TableCell align="left">{row.description?.toString()?.split('\n')[0]}</TableCell>
                                        <TableCell align="left">{row.startDateTime}</TableCell>
                                        <TableCell align="left">{(row.statusCd !== 0) ? row.endDateTime : ''}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box className="dashboard-box">
                        <Grid container spacing={3}>
                            <Grid item xs={6} sx={{ textAlign: "center"}}>
                                <img width={400} src={ProjectManagement}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="h6" component="div" className='title'>
                                    {translate('dashboarddescription_3')}
                                </Typography>
                                <Typography variant="body1" component="div" className='sub-title'>
                                    {translate('dashboarddescription_4')}
                                </Typography>
                                <Box sx={{ my: 4, display: "flex", justifyContent: "center", gap: 5 }}>
                                    <Button variant="contained" color="primary" component={Link} to="/control-center/documentation/gettingstarted/installation/" endIcon={<KeyboardArrowRightIcon />}>
                                        {translate('gettingstarted')}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}
function mapStateToProps(state) {
    return {
        BackDrop: state.BackDrop,
        UserInfor: state.UserInfor,
    }
  }
export default connect(mapStateToProps)(withTranslate(Dashboard));